import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    shareinfos(data) {
        return axios.request({
            url: "api/shareinfos",
            method: "post",
            data
        });
    },
    wxLoginWap(data) {
        return axios.request({
            url: "user/login-wx-wap",
            method: "post",
            data
        });
    },
    appLaunch() {
        return axios.request({
            url: "api/launch"
        })
    },
    upload({content, imgkey}) {

        var formData = new FormData();
        var arr = content.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        if (!imgkey) imgkey = 'myfile'
   
        let suffix = content.split(';')[0].split(':')[1].split('/')[1];
        var filename = String(new Date().getTime())+'.'+suffix;

        formData.append(imgkey, new File([u8arr], `${imgkey}/${filename}`, {type: mime}));
        formData.append("imgkey", imgkey);
        formData.append("name", imgkey);


        return axios.request({
            url: "site/fileupload",
            method: "post",
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}
